export const CommunityFeedTabs = {
    TIMELINE: 'TIMELINE',
    GALLERY: 'GALLERY',
    MEMBERS: 'MEMBERS',
    PENDING: 'PENDING',
};
//# sourceMappingURL=constants.js.map